<template>
  <div class="chat-member-box flex flex-inline pt-1 px-2 items-center">
    <div
      class="chatroom-member-list">
      <template v-for="(member, index) in checkIsNotOwner(members)" >
        <div
          v-if="member !== $currentUser.uuid"
          :key="member.uuid"
          class="chatroom-member-list-avatar-container"
          :style="`right: ${26 * (index + 1)}px; z-index: ${1000 - index}`"
        >
          <ChatAvatar
            :mode="'chat-head'"
            :member="member"
          />
        </div>
      </template>
    </div>
    <ChatAvatar :member="$currentUser" :mode="'chat-head'" :isOwner="true" style="z-index: 1000" />
  </div>
</template>

<script>
export default {
  components: {
    ChatAvatar: () => import("./ChatMemberAvatar")
  },
  props: {
    members: {
      type: Array,
      default: null
    }
  },
  methods: {
    checkIsNotOwner(members) {
      if (Array.isArray(members)) {
        // return members
        //   .filter(member => member.uuid ? member.uuid !== this.$currentUser.uuid : null)
        //   .sort((a, b) => (a && b) ? a.timestamp - b.timestamp : null)
        return members
          .filter(member => member !== this.$currentUser.uuid)
          .sort((a, b) => (a && b) ? a.timestamp - b.timestamp : null)
      }
    }
  }
}
</script>
